import {signInTypes} from "../AuthActionsTypes/SignInActionsTypes";

export const removeUserSignInErrors = error => {
    return {
        type: signInTypes.REMOVE_ERRORS,
    };
};


export const setUserSignInUnknownError = error => {
    return {
        type: signInTypes.SET_ERROR,
        name: signInTypes.UNKNOWN_ERROR,
    };
};

/**
 * Set sign in Error 400
 * @param error {object} The response error.
 * @returns {{type: {string} The action type, message: object The error message object}}
 */
export const setUserSignInError400 = error => {
    const {data} = error.response;
    const {message} = data;

    const errorsMessage = message
        .map(message => ({[message.property]: message.errors[0]}))
        .reduce(((result, item) => Object.assign(result, item)), {});

    return {
        type: signInTypes.SET_ERRORS,
        message: errorsMessage,
    };
};

/**
 * Set sign in Error 401
 * @param error {object} The response error.
 * @returns {{type: {string} The action type, message: object The error message object}}
 */
export const setUserSignInError401 = error => {
    const errorMessage = "The email or password you entered is incorrect. Please enter right credentials and try again";

    return {
        type: signInTypes.SET_ERROR,
        name: signInTypes.USER_SIGN_IN_GENERAL_ERROR,
        message: errorMessage,
    };
};

/**
 * Set general error.
 * @param error {object} The response error.
 * @returns {{name: *, type: *, message: *}}
 */
export const setUserSignInGeneralError = error => {
    const {data} = error.response;
    const {message} = data;

    return {
        type: signInTypes.SET_ERROR,
        name: signInTypes.GENERAL_ERROR,
        message: message,
    };
};

export const setUserSignInError = error => {
    if (!error.response) {
        return setUserSignInUnknownError(error);
    }

    const {data} = error.response;

    if (data.statusCode === 400)
        return setUserSignInError400(error);
    else if (data.statusCode === 401)
        return setUserSignInError401(error);

    return setUserSignInGeneralError(error);
};
